export function isResponding(state) {
  return state.pairingResponder.isResponding;
}
export function getRequesterDeviceName(state) {
  return state.pairingResponder.request?.name;
}
export function getRequest(state) {
  return state.pairingResponder.request;
}
export function getError(state) {
  return state.pairingResponder.error;
}
